import React, { useState, useEffect } from 'react';
import Resizer from "react-image-file-resizer";
import VisualizzaAllegato from '../Pagine/VisualizzaAllegato';
import { convertiDataComputer2Umano, oggiData } from './funzioni.js' // funzioni di AppClienti
import { haPersonalizzazione } from '../funzioni.js'; // funzioni generale
import Clessidra from '../Pagine/Clessidra'
import stile from './stile.module.css';

function Scadenze(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "elencoScadenze": 2,
        "aggiornaDocumento": 3,
    };
    var oggi = oggiData(); // AAAA-MM-GG
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [dovutoAbbonamenti, setDovutoAbbonamenti] = useState(0);
    const [dovutoAssociative, setDovutoAssociative] = useState(0);
    const [elencoProssimeSpese, setElencoProssimeSpese] = useState([]); // json
    const [flagAbbonamenti,setFlagAbbonamenti] = useState(false);
    const [flagAssociative, setFlagAssociative] = useState(false)
    const [flagProssimeSpese, setFlagProssimeSpese] = useState(false)
    const [dataFineCertMedico, setDataFineCertMedico] = useState("");
    const [dataFineDocIdentita, setDataFineDocIdentita] = useState("");
    const [dataFineDocPrivacy, setDataFineDocPrivacy] = useState("");

    const [richiestoCertMedico, setRichiestoCertMedico] = useState("");
    const [richiestoDocIdentita, setRichiestoDocIdentita] = useState("");
    const [richiestoDocPrivacy, setRichiestoDocPrivacy] = useState("");

    const [tipoDocumentoModifica, setTipoDocumentoModifica] = useState(""); // certMedico, documento, privacy
    const [titoloDocumentoModifica, setTitoloDocumentoModifica] = useState("");
    const [dataScadenzaDocumentoModifica, setDataScadenzaDocumentoModifica] = useState("");
    const [contenutoFileDocumentoModifica, setContenutoFileDocumentoModifica] = useState("");
    const [typeFileDocumentoModifica, setTypeFileDocumentoModifica] = useState("");
    const [estensioneFileDocumentoModifica, setEstensioneFileDocumentoModifica] = useState("");
    const [flagDocumentoModificato, setFlagDocumentoModificato] = useState(false);
    const [memorizzazioneInCorso, setMemorizzazioneInCorso] = useState(false);

    function scaricaElencoScadenze() {
        setPagina(PAGINE.caricamentoDati);
        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op: "elencoScadenze", emak: props.emak, sessionId: props.sessionId })
        };
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                        window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }
                    if (valore_di_ritorno.dovutoAbbonamenti!=undefined) {
                        setFlagAbbonamenti(true);
                        setDovutoAbbonamenti(valore_di_ritorno.dovutoAbbonamenti);
                    }
                    if (valore_di_ritorno.dovutoAssociative!=undefined) {
                        setFlagAssociative(true);
                        setDovutoAssociative(valore_di_ritorno.dovutoAssociative);
                    }
                    if (valore_di_ritorno.prossimeSpese!=undefined) {
                        setFlagProssimeSpese(true);
                        setElencoProssimeSpese(valore_di_ritorno.prossimeSpese);
                    }
                    setDataFineCertMedico(valore_di_ritorno.dataFineCertMedico);
                    setDataFineDocIdentita(valore_di_ritorno.dataFineDocIdentita);
                    setDataFineDocPrivacy(valore_di_ritorno.dataFineDocPrivacy);

                    setRichiestoCertMedico(valore_di_ritorno.richiestoCertMedico);
                    setRichiestoDocIdentita(valore_di_ritorno.richiestoDocIdentita);
                    setRichiestoDocPrivacy(valore_di_ritorno.richiestoDocPrivacy);

                    setPagina(PAGINE.elencoScadenze);
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );                
        setPagina(PAGINE.caricamentoDati);         
    }

function apriAggiornamentoDocumento(tipo) {

    setPagina(PAGINE.caricamentoDati);
    setTipoDocumentoModifica(tipo);
    setFlagDocumentoModificato(false);

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            op: "personeRecuperaDati",
            emak: props.emak,
            sessionId: props.sessionId
        })
    };

    fetch(props.UrlBackend, requestOptions)
        .then(risposta => risposta.json())
        .then(
            (valoreDiRitorno) => {

                if (valoreDiRitorno.risultatoOperazione === 2) {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }

                if (valoreDiRitorno.risultatoOperazione !== 1) {
                    window.alert("Si è verificato un errore durante il recupero del documento");
                    setPagina(PAGINE.elencoScadenze);
                    return;
                }

                const persona = valoreDiRitorno.risultatoRitorno[0];

                switch (tipo) {

                    case "certMedico":
                        setTitoloDocumentoModifica("Certificato medico");
                        setDataScadenzaDocumentoModifica(persona.DATA_FINE_CERT_MEDICO || "");
                        setContenutoFileDocumentoModifica(persona.FILE_CERT_MEDICO || "");
                        setTypeFileDocumentoModifica(persona.TYPE_FILE_CERT_MEDICO || "");
                        setEstensioneFileDocumentoModifica(persona.ESTENSIONE_FILE_CERTMEDICO || "");
                        break;

                    case "documento":
                        setTitoloDocumentoModifica("Documento di identità");
                        setDataScadenzaDocumentoModifica(persona.DATA_DOC_IDENTITA || "");
                        setContenutoFileDocumentoModifica(persona.FILE_DOCUMENTO || "");
                        setTypeFileDocumentoModifica(persona.TYPE_FILE_DOCUMENTO || "");
                        setEstensioneFileDocumentoModifica(persona.ESTENSIONE_FILE_DOCUMENTO || "");
                        break;

                    default:
                        window.alert("Tipo documento non valido");
                        setPagina(PAGINE.elencoScadenze);
                        return;
                }

                setPagina(PAGINE.aggiornaDocumento);
            },
            () => {
                window.alert("Errore di connessione");
                setPagina(PAGINE.elencoScadenze);
            }
        );
    }    

    function aggiornaDocumentoFile(valore) {
        if (!valore) return;
        let typeFile = valore.type;

        if (valore.type && valore.type.substring(0, 5) === "image") {

            let nuovoTipo = valore.type.substring(6);

            if (
                nuovoTipo.toUpperCase() !== "JPG" &&
                nuovoTipo.toUpperCase() !== "JPEG" &&
                nuovoTipo.toUpperCase() !== "PNG"
            ) {
                nuovoTipo = "JPEG";
                typeFile = "image/jpeg";
            }

            try {
                Resizer.imageFileResizer(
                    valore,
                    600,
                    600,
                    nuovoTipo,
                    100,
                    0,
                    (uri) => {
                        setContenutoFileDocumentoModifica(uri);
                    },
                    "base64"
                );
            } catch (err) {
                alert("Si è verificato un errore nel ridimensionamento dell'immagine");
                return;
            }

        } else {
            setContenutoFileDocumentoModifica(valore);
        }

        const estensione = valore.name.split('.').pop();

        setTypeFileDocumentoModifica(typeFile);
        setEstensioneFileDocumentoModifica(estensione);
        setFlagDocumentoModificato(true);
    }

    function memorizzaDocumento() {

        const formData = new FormData();

        formData.append('op', 'personeMod');
        formData.append('emak', props.emak);
        formData.append('sessionId', props.sessionId);

        formData.append('modificaDocumentoDaApp', '1');
        formData.append('tipoDocumento', tipoDocumentoModifica);

        if (tipoDocumentoModifica === "certMedico") {

            formData.append(
                'dataFineCertMedico',
                dataScadenzaDocumentoModifica
            );

            if (flagDocumentoModificato) {
                formData.append(
                    'contenutoFileCertMedico',
                    contenutoFileDocumentoModifica
                );
                formData.append(
                    'typeFileCertMedico',
                    typeFileDocumentoModifica
                );
                formData.append(
                    'estensioneFileCertMedico',
                    estensioneFileDocumentoModifica
                );
            }

        } else if (tipoDocumentoModifica === "documento") {

            formData.append(
                'dataDocIdentita',
                dataScadenzaDocumentoModifica
            );

            if (flagDocumentoModificato) {
                formData.append(
                    'contenutoFileDocumento',
                    contenutoFileDocumentoModifica
                );
                formData.append(
                    'typeFileDocumento',
                    typeFileDocumentoModifica
                );
                formData.append(
                    'estensioneFileDocumento',
                    estensioneFileDocumentoModifica
                );
            }
        }

        setMemorizzazioneInCorso(true);

        fetch(props.UrlBackend, {
            method: 'POST',
            body: formData
        })
        .then(risposta => risposta.json())
        .then(
            valoreDiRitorno => {

                setMemorizzazioneInCorso(false);

                if (valoreDiRitorno.risultatoOperazione === 2) {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }

                if (valoreDiRitorno.risultatoOperazione !== 1) {

                    window.alert(
                        valoreDiRitorno.mess !== undefined
                        ? valoreDiRitorno.mess
                        : "Errore durante la memorizzazione"
                    );

                    return;
                }

                scaricaElencoScadenze();
            },
            () => {
                setMemorizzazioneInCorso(false);
                window.alert("Errore di connessione");
            }
        );
    }

    useEffect(() => {
        scaricaElencoScadenze();
    }, [])
    
    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);
        } 
    }, [props.flagRichiestaBack])  

    if (pagina === PAGINE.caricamentoDati) {
        return (<Clessidra loading={true} />)
    }

    if (pagina === PAGINE.elencoScadenze) {
        return (
            <div className={stile.contenitorePrincipale}>
                <div className={stile.scadenzeTestoNomePersona}>
                    {props.identitaSelezionata.cognome} {props.identitaSelezionata.nome}
                </div>
        
                {richiestoCertMedico == 1 ?
                    <div className={stile.scadenzeElencoContenitoreElemento}>
                        <div className={stile.scadenzeElencoTestoTitolo}>Certificato medico</div>
                        {dataFineCertMedico === "" ? (
                            <div className={stile.scadenzeElencoTestoAllarme}>NON PRESENTATO</div>
                        ) : dataFineCertMedico < oggi ? (
                            <div className={stile.scadenzeElencoTestoAllarme}>
                                SCADUTO {convertiDataComputer2Umano(dataFineCertMedico)}
                            </div>
                        ) : (
                            <div className={stile.scadenzeElencoTestoNormale}>
                                scade {convertiDataComputer2Umano(dataFineCertMedico)}
                            </div>
                        )}

                        {haPersonalizzazione(props.identitaSelezionata,"app_aggiorna_certificato_medico") && 
                            <div className={stile.scadenzeSpazioBottoni}>
                                <div
                                    className={stile.scadenzeBottone}
                                    onClick={() => apriAggiornamentoDocumento("certMedico")}
                                >
                                    Aggiorna certificato medico
                                </div>                        
                            </div>
                        }

                    </div>
                :""}
        
                {richiestoDocIdentita == 1 ?
                    <div className={stile.scadenzeElencoContenitoreElemento}>
                        <div className={stile.scadenzeElencoTestoTitolo}>Documento di identità</div>
                        {dataFineDocIdentita === "" ? (
                            <div className={stile.scadenzeElencoTestoAllarme}>NON PRESENTATO</div>
                        ) : dataFineDocIdentita < oggi ? (
                            <div className={stile.scadenzeElencoTestoAllarme}>
                                SCADUTO {convertiDataComputer2Umano(dataFineDocIdentita)}
                            </div>
                        ) : (
                            <div className={stile.scadenzeElencoTestoNormale}>
                                valido fino a {convertiDataComputer2Umano(dataFineDocIdentita)}
                            </div>
                        )}

                        {haPersonalizzazione(props.identitaSelezionata,"app_aggiorna_certificato_identita") && 
                            <div className={stile.scadenzeSpazioBottoni}>
                                <div
                                    className={stile.scadenzeBottone}
                                    onClick={() => apriAggiornamentoDocumento("documento")}
                                >
                                    Aggiorna documento di identità
                                </div>                        
                            </div>
                        }

                    </div>
                :""}

                {richiestoDocPrivacy == 1 ?
                    <div className={stile.scadenzeElencoContenitoreElemento}>
                        <div className={stile.scadenzeElencoTestoTitolo}>Documento Privacy</div>
                        {dataFineDocPrivacy === "" ? (
                            <div className={stile.scadenzeElencoTestoAllarme}>NON PRESENTATO</div>
                        ) : dataFineDocPrivacy < oggi ? (
                            <div className={stile.scadenzeElencoTestoAllarme}>
                                SCADUTO {convertiDataComputer2Umano(dataFineDocPrivacy)}
                            </div>
                        ) : (
                            <div className={stile.scadenzeElencoTestoNormale}>
                                valido fino a {convertiDataComputer2Umano(dataFineDocPrivacy)}
                            </div>
                        )}
                    </div>
                :""}
        

                {flagAbbonamenti ? (
                    <div className={stile.scadenzeElencoContenitoreElemento}>
                        <div className={stile.scadenzeElencoTestoTitolo}>Abbonamenti</div>
                        {dovutoAbbonamenti === 0 ? (
                            <div className={stile.scadenzeElencoTestoNormale}>Nessun arretrato</div>
                        ) : dovutoAbbonamenti > 0 ? (
                            <div className={stile.scadenzeElencoTestoAllarme}>
                                {dovutoAbbonamenti} EURO DI ARRETRATI
                            </div>
                        ) : (
                            <div className={stile.scadenzeElencoTestoNormale}>
                                {-dovutoAbbonamenti} EURO DI CREDITI
                            </div>
                        )}
                    </div>
                ) : null}
        
                {flagAssociative ? (
                    <div className={stile.scadenzeElencoContenitoreElemento}>
                        <div className={stile.scadenzeElencoTestoTitolo}>Quote associative</div>
                        {dovutoAssociative === 0 ? (
                            <div className={stile.scadenzeElencoTestoNormale}>Nessun arretrato</div>
                        ) : dovutoAssociative > 0 ? (
                            <div className={stile.scadenzeElencoTestoAllarme}>
                                {dovutoAssociative} EURO DI ARRETRATI
                            </div>
                        ) : (
                            <div className={stile.scadenzeElencoTestoNormale}>
                                {-dovutoAssociative} EURO DI CREDITI
                            </div>
                        )}
                    </div>
                ) : null}
        
                {flagProssimeSpese ? (
                    <div className={stile.scadenzeElencoContenitoreElemento}>
                        <div className={stile.scadenzeElencoTestoTitolo}>
                            Pagamenti nei prossimi 30 giorni
                        </div>
                        {elencoProssimeSpese.map((x, i) => (
                            <div key={i}>
                                <div className={stile.scadenzeElencoTestoNormale}>
                                    {convertiDataComputer2Umano(x.DATA)}: {x.IMPORTO} EURO <br />
                                    per {x.OPERAZIONE}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        );
        
    }

    if (pagina === PAGINE.aggiornaDocumento) {

        return (
            <div className={stile.contenitorePrincipale}>

                <div className={stile.scadenzeTestoNomePersona}>
                    {props.identitaSelezionata.cognome} {props.identitaSelezionata.nome}
                </div>

                <div className={stile.scadenzeElencoContenitoreElemento}>

                    <div className={stile.scadenzeElencoTestoTitolo}>
                        {titoloDocumentoModifica}
                    </div>

                    <div style={{marginTop: "20px"}}>
                        <label>
                            Data di scadenza
                        </label>

                        <input
                            type="date"
                            value={dataScadenzaDocumentoModifica}
                            onChange={(e) =>
                                setDataScadenzaDocumentoModifica(e.target.value)
                            }
                            style={{
                                display: "block",
                                marginTop: "5px",
                                marginBottom: "20px"
                            }}
                        />
                    </div>

                    <VisualizzaAllegato
                        cssContenitore={stile.scadenzeDocumentoContenitore}
                        cssImmagine={stile.scadenzeDocumentoImmagine}
                        cssPdf={stile.scadenzeDocumentoPdf}
                        cssTestoEstensione={stile.scadenzeDocumentoEstensione}

                        contenutoFile={contenutoFileDocumentoModifica}
                        tipoFile={typeFileDocumentoModifica}
                        estensioneFile={estensioneFileDocumentoModifica}

                        estensioniAccettate={
                            ".jpg,.jpeg,.gif,.png,.webp,.pdf,.odt,.doc,.docx"
                        }

                        flagContenutoModificato={flagDocumentoModificato}

                        callbackAggiornaFile={(e) => {
                            if (
                                e.target.files !== undefined &&
                                e.target.files.length > 0
                            ) {
                                aggiornaDocumentoFile(e.target.files[0]);
                            }
                        }}
                    />

                    <div className={stile.scadenzeSpazioBottoni}>

                        <div
                            className={stile.scadenzeBottone}
                            onClick={() => {
                                if (!memorizzazioneInCorso) {
                                    memorizzaDocumento();
                                }
                            }}
                        >
                            {memorizzazioneInCorso
                                ? "Memorizzazione..."
                                : "Memorizza"}
                        </div>

                        <div
                            className={stile.scadenzeBottone}
                            onClick={() => {
                                if (!memorizzazioneInCorso) {
                                    setPagina(PAGINE.elencoScadenze);
                                }
                            }}
                        >
                            Annulla
                        </div>

                    </div>

                </div>

            </div>
        );
    }

    return (
        <div>Errore pagina non trovata (Scadenze)</div>
    )
}

export default Scadenze;
